<template>
  <div>
    <q-form @submit="this.onSubmit" class="form">
      <div class="form__item">
        <div class="info-field">
          <q-icon name="task_alt" size="20px" color="primary" class="field-icon" />
          <span class="info-label">Задача:</span>
          <span class="info-value">{{ this.data?.task_name || '-' }}</span>
        </div>
      </div>
      <div class="form__item">
        <div class="info-field">
          <q-icon name="event" size="20px" color="primary" class="field-icon" />
          <span class="info-label">Дата:</span>
          <span class="info-value">{{ formatDate(this.data?.fact_date) }}</span>
        </div>
      </div>
      <div class="form__item">
        <CustomInput
          label="Факт"
          type="number"
          :value="this.formData.fact_value"
          @change_input="(value) => onChange('fact_value', value)"
          placeholder="Введите значение"
          class="fact-input"
        />
      </div>
      <div v-if="this.data?.debug_info" class="form__item debug-info">
        <div class="debug-title">Отладочная информация:</div>
        <div class="debug-field">
          <span class="debug-label">work_group_id:</span>
          <span class="debug-value">{{ this.data.debug_info.work_group_id || 'null' }}</span>
        </div>
        <div class="debug-field">
          <span class="debug-label">task_dict_id:</span>
          <span class="debug-value">{{ this.data.debug_info.task_dict_id || 'null' }}</span>
        </div>
        <div class="debug-field">
          <span class="debug-label">work_group_level_id:</span>
          <span class="debug-value">{{ this.data.debug_info.work_group_level_id || 'null' }}</span>
        </div>
        <div class="debug-field">
          <span class="debug-label">date_:</span>
          <span class="debug-value">{{ this.data.debug_info.date_ || 'null' }}</span>
        </div>
      </div>
      <div class="form__footer">
        <div v-if="this.data?.work_task_fact_id" class="delete-btn-container">
          <q-btn
            label="Удалить"
            color="negative"
            outline
            :loading="this.loading"
            @click="onDelete"
            class="delete-btn"
          />
        </div>
        <CustomModalFooter :btn-loading="this.loading" />
      </div>
    </q-form>
  </div>
</template>

<script>
import CustomInput from "@/components/form/CustomInput";
import CustomModalFooter from "@/components/modal/modals/modal-footer";

export default {
  name: "edit-tier-fact",
  components: { CustomInput, CustomModalFooter },
  props: ['data'],
  data() {
    return {
      loading: false,
      formData: {
        fact_value: this.data?.fact_value || '',
      }
    }
  },
  methods: {
    onChange(key, value) {
      this.formData[key] = value
    },
    formatDate(date) {
      if (!date) return '-';
      // Преобразуем YYYY-MM-DD в DD.MM.YYYY
      const parts = date.split('-');
      if (parts.length === 3) {
        return `${parts[2]}.${parts[1]}.${parts[0]}`;
      }
      return date;
    },
    async onSubmit() {
      this.loading = true
      // Передаем все необходимые данные включая task_dict_id и work_group_level_id из data
      // При создании (work_task_fact_id = null) все обязательные поля должны быть переданы
      const submitData = {
        fact_value: this.formData.fact_value || null,
        work_task_fact_id: this.data?.work_task_fact_id || null,
        work_group_id: this.data?.work_group_id,
        task_dict_id: this.data?.task_dict_id || null,
        fact_date: this.data?.fact_date,
        work_group_level_id: this.data?.work_group_level_id || null,
      }
      await this.data?.onSubmit(submitData)
      this.loading = false
    },
    async onDelete() {
      this.loading = true
      const deleteData = {
        work_task_fact_id: this.data?.work_task_fact_id,
      }
      await this.data?.onDelete(deleteData)
      this.loading = false
    },
  },
}
</script>

<style scoped lang="scss">
.form {
  display: flex;
  flex-direction: column;
  width: 280px;
  gap: 8px;
  margin-top: 5px;

  @media (max-width: 428px) {
    width: 100%;
  }
}

.form__item {
  margin-bottom: 0;
}

.info-field {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 0;
  font-size: 13px;
  
  .field-icon {
    flex-shrink: 0;
  }
  
  .info-label {
    font-weight: 600;
    min-width: 60px;
    color: #666;
  }
  
  .info-value {
    color: #333;
    font-size: 13px;
  }
}

.fact-input {
  width: 100%;
  
  :deep(input) {
    text-align: center;
  }
}

.form__footer {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 4px;
}

.delete-btn-container {
  display: flex;
  justify-content: flex-start;
  padding-top: 6px;
  border-top: 1px solid #e0e0e0;
}

.delete-btn {
  min-width: 100px;
}

.debug-info {
  margin-top: 12px;
  padding: 12px;
  background-color: #f5f5f5;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
}

.debug-title {
  font-weight: 600;
  font-size: 12px;
  color: #666;
  margin-bottom: 8px;
  text-transform: uppercase;
}

.debug-field {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 0;
  font-size: 12px;
  border-bottom: 1px solid #e0e0e0;
  
  &:last-child {
    border-bottom: none;
  }
}

.debug-label {
  font-weight: 600;
  color: #666;
  min-width: 140px;
}

.debug-value {
  color: #333;
  font-family: monospace;
  word-break: break-all;
  text-align: right;
}
</style>

